import {
  CourseQuestion,
  QuestionType,
} from '../jumpstart-communicator/jumpstart-communicator.types';

export const course_questions: CourseQuestion[] = [
  {
    id: 'ff27a98d-8908-4490-ad2f-9b4b54f51144',
    question:
      'Read the statements. Put a check mark beside those you to be true about collaboration.',
    options: [
      {
        id: '54f34f1b-7021-42ef-86bc-7f70ceb989fe',
        option: 'Effective teams depends on "social sensitivity"',
      },
      {
        id: '679e29e6-2175-4135-93d5-0e38eae18e7e',
        option: 'A balance of extroverts and introverts makes foea a better team',
      },
      {
        id: 'bb1f9e26-ee12-4510-8247-305eb7ff05a3',
        option: 'The mere presence of other people can boost your performance',
      },
      {
        id: '6b515a4c-7963-450a-a949-29de5be67ae4',
        option: 'The culture of a workplace impacts how we work with others',
      },
      {
        id: 'f55825b9-dbbe-43aa-9fff-ff019ba311d1',
        option: 'Inclusive teams perform better',
      },
      {
        id: 'a317547f-50d8-4044-8d9c-00766d02be42',
        option: 'Coolaborative work teams have advantages like sports teams in their home stadiums',
      },
    ],
    answers: [
      '54f34f1b-7021-42ef-86bc-7f70ceb989fe',
      '679e29e6-2175-4135-93d5-0e38eae18e7e',
      'bb1f9e26-ee12-4510-8247-305eb7ff05a3',
      '6b515a4c-7963-450a-a949-29de5be67ae4',
      'f55825b9-dbbe-43aa-9fff-ff019ba311d1',
      'a317547f-50d8-4044-8d9c-00766d02be42',
    ],
    answer_description:
      'That’s right! Your message will change depending on your tone of voice. Consider how saying “That’s great for you” is offensive if it’s said in a sarcastic tone. Remember, your tone should match your intention.',
    type: QuestionType.CHECKBOX,
    chapter_id: '0fcb3269-0afb-4208-936c-7cf12837a534',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',

    wrong_answer_description: 'In fact, all these statements on collaboration are true.',
  },
];

export const course_quiz_questions: CourseQuestion[] = [
  {
    id: 'e282f222-99bf-4a7c-8a73-39caee866bff',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'What are the four main areas of responsibility in a successful team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '92025b75-2c47-4220-873d-2aeb50c83a8c',
        description: '',
        option: 'Management, marketing, sales, and execution',
      },
      {
        id: '862730e7-3622-4961-a74e-3597bf864fb6',
        description: '',
        option: 'Planning, creativity, execution, and evaluation',
      },
      {
        id: '19200535-7bc5-4d86-94e5-f4daaceb89eb',
        option: 'Management, people care, creativity, and execution',
        description: '',
      },
      {
        id: 'f8b62ab7-4de0-486d-ac22-bdb3d88364d8',
        option: 'Management, people care, creativity, and execution',
        description: '',
      },
      {
        id: '87e8fc79-633d-439b-9b1e-c85df193c11f',
        option: 'Vision, leadership, communication, and task completion',
        description: '',
      },
    ],
    answers: ['f8b62ab7-4de0-486d-ac22-bdb3d88364d8'],
    wrong_answer_description:
      'The Four main areas of responsibility in a successful team include: management, people care, creativity, and exection ',
    answer_description:
      'The Four main areas of responsibility in a successful team include: management, people care, creativity, and exection ',
  },
  {
    id: '84a4cb29-237d-4d70-86b9-d763fa63b0b3',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'Which role is described as having a strategic long-term perpective within a team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '7f9b98ab-aa32-4ad9-9a7e-ef56f66215e8',
        description: '',
        option: 'Organizer',
      },
      {
        id: '85b450e2-5f46-4942-8d4d-ecb044d87310',
        description: '',
        option: 'Driver',
      },
      {
        id: 'e30ba5e5-f195-46b3-9a52-fb7acd8d8846',
        option: 'Visionary',
        description: '',
      },
      {
        id: '316d6a84-0d94-454a-8502-de1565610bd6',
        option: 'Carer',
        description: '',
      },
    ],
    answers: ['e30ba5e5-f195-46b3-9a52-fb7acd8d8846'],
    wrong_answer_description:
      'The visionary role is described as having a strategic long-term perspective within a team.',
    answer_description:
      'The visionary role is described as having a strategic long-term perspective within a team.',
  },
  {
    id: 'dff27e66-071b-4461-8071-d48403331ab6',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'What does the `Judge´ role focus on in the context of creativity and problem-solving?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'dabc0e54-b17d-46a9-ab77-4fcbb63dc1f5',
        description: '',
        option: 'Generating new ideas',
      },
      {
        id: 'ef65d419-8859-4126-b596-db0306fda28f',
        description: '',
        option: 'Evaluating options and making decisions',
      },
      {
        id: '458f1603-5f3c-4449-89e2-10be97a67b5a',
        option: 'Pointing out flaws in plans',
        description: '',
      },
      {
        id: '9a617f93-c271-4e58-804a-ab108d5ecd52',
        option: 'Motivating team members',
        description: '',
      },
    ],
    answers: ['ef65d419-8859-4126-b596-db0306fda28f'],
    wrong_answer_description:
      'The ‘Judge’ role focuses on evaluating options and making decisions in the context of creativity and problem-solving.',
    answer_description:
      'The ‘Judge’ role focuses on evaluating options and making decisions in the context of creativity and problem-solving.',
  },
  {
    id: '49abdb5b-9f7b-414f-a6ee-63bf662e6f02',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'Why is identifying your strengths important in teamwork?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '1677a199-2973-453b-9a62-f8a6fd630bbc',
        description: '',
        option: 'To shown off your skills',
      },
      {
        id: 'b0f91ae3-18e1-4bf0-b4db-6f54b5c61b5d',
        description: '',
        option: 'To understand yourself better and improve team perfomrance',
      },
      {
        id: '6c46f096-233c-4685-9957-5d51122beb2e',
        option: 'To avoid working with others',
        description: '',
      },
      {
        id: 'dd22e8f2-7750-4f29-a3ce-bd4fd15ef14c',
        option: 'To compete with team members',
        description: '',
      },
    ],
    answers: ['b0f91ae3-18e1-4bf0-b4db-6f54b5c61b5d'],
    wrong_answer_description:
      'Identifying your strengths is important in teamwork to understand yourself better and improve team performance.',
    answer_description:
      'Identifying your strengths is important in teamwork to understand yourself better and improve team performance.',
  },
  {
    id: 'a15e3325-4284-4c93-a8ef-4bfab2cf6766',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'What should you do once you know your strengths?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '4b10e253-83fc-4773-8c62-d164ee66cb97',
        description: '',
        option: 'Keep them to yourself',
      },
      {
        id: '4db88295-f39e-4d0e-9cbc-8211c7230baf',
        description: '',
        option: 'Use them to dominate the team',
      },
      {
        id: 'ea01ef50-f9d3-45f0-b128-43ef1af36d9a',
        option: 'Put them to work and look for opportunities to contribute',
        description: '',
      },
      {
        id: '3ccc0670-ac7f-45c9-a73c-965a41c131db',
        option: 'Ignore them and focus on weaknesses',
        description: '',
      },
    ],
    answers: ['ea01ef50-f9d3-45f0-b128-43ef1af36d9a'],
    wrong_answer_description:
      'Once you know your strengths put them to work and look for opportunities to contribute.',
    answer_description:
      'Once you know your strengths put them to work and look for opportunities to contribute.',
  },
  {
    id: 'e5104bb2-04af-4286-a709-33f9043323b0',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'Why is it important to explore your weaknesses in a team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '04f8ea67-be57-4472-9faf-5f95df61a612',
        description: '',
        option: 'To feel bad about yourself',
      },
      {
        id: '7bc7fb72-a87b-40d3-8f45-3d6cba3d56a4',
        description: '',
        option: 'To let others know you can’t do much',
      },
      {
        id: 'b684dc6b-7869-490a-ac45-e867b12457b3',
        option: 'To foster trust and improve collaboration',
        description: '',
      },
      {
        id: 'e6d892ed-3480-4122-968b-095f5347e829',
        option: 'To avoid team tasks altogether',
        description: '',
      },
    ],
    answers: ['b684dc6b-7869-490a-ac45-e867b12457b3'],
    wrong_answer_description:
      'It is important to explore your weaknesses in a team to foster trust and improve collaboration.',
    answer_description:
      'It is important to explore your weaknesses in a team to foster trust and improve collaboration.',
  },
  {
    id: '0c7424df-573d-4507-96d2-c7a3e03b6d67',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Why is it beneficial to appreciate the strenghts of team members who are different from you?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '1f5bec06-eb3d-4f85-b589-6fe0d8405d9b',
        description: '',
        option: 'It reduces the need for communication',
      },
      {
        id: '1ee01b4a-22c2-4112-a85d-834653837dc2',
        description: '',
        option: 'It helps you dominate the team',
      },
      {
        id: 'c5928190-d254-4ace-b438-91edf108f63d',
        option: 'It allows you to use their strengths to achieve team goals',
        description: '',
      },
      {
        id: '51e2c230-13bc-4197-b928-532a5f2aec02',
        option: 'It minimizes the role of other team members',
        description: '',
      },
    ],
    answers: ['c5928190-d254-4ace-b438-91edf108f63d'],
    wrong_answer_description:
      'It is beneficial to appreciate the strengths of team members who are different from you as it allows you to use their strengths to achieve team goals. ',
    answer_description:
      'It is beneficial to appreciate the strengths of team members who are different from you as it allows you to use their strengths to achieve team goals. ',
  },
  {
    id: 'e74a7208-2e20-43bc-89fb-80c000ef9217',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Scenario: You are part of a soccer team, and you notice that one of your teammates is struggling with a particular skill. What would be the best way to show collaboration?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'f7a8add6-278a-45a2-bf62-dc171c15d0e4',
        description: '',
        option: 'Ignore them and focus on your own skills.',
      },
      {
        id: '4e8ef35d-a2c2-4d3c-83c5-8230e43a7ad3',
        description: '',
        option: 'Offer to help them practice and improve.',
      },
      {
        id: '622cd5dd-ff02-4e1c-b941-1eddc5bd578a',
        option: 'Tell the coach they are not good enough.',
        description: '',
      },
      {
        id: '8a4f0d24-ae36-4017-8e51-7ce9d13e841c',
        option: 'Take over their position in the game.',
        description: '',
      },
    ],
    answers: ['4e8ef35d-a2c2-4d3c-83c5-8230e43a7ad3'],
    wrong_answer_description:
      'The best way to show collaboration is to offer to help them practice and improve.',
    answer_description:
      'The best way to show collaboration is to offer to help them practice and improve.',
  },
  {
    id: '9ca7f1eb-b248-4aa4-976e-874d94850f23',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Scenario: You and your family are planning a vacation, and everyone has diffeent ideas about where to go. How can you collaborate effectively to decide on destination?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '3b0220ad-9001-4519-8300-526f88dd2351',
        description: '',
        option: 'Let one person make the final decision.',
      },
      {
        id: '39b817af-df4e-4000-a6af-5fd3adde4b98',
        description: '',
        option: 'Decide to not go on vacation to avoid conflict.',
      },
      {
        id: '89bf6d0d-c088-4956-bac1-836254417f73',
        option: 'Argue untill everyone agrees on one place.',
        description: '',
      },
      {
        id: '1c9f17ce-bbe9-422c-a34f-2e0e2453978e',
        option: 'Vote on the options and choose the most popular destination.',
        description: '',
      },
    ],
    answers: ['1c9f17ce-bbe9-422c-a34f-2e0e2453978e'],
    wrong_answer_description:
      'Collaborate effectively to decide on a destination by voting on the options and choose the most popular destination.',
    answer_description:
      'Collaborate effectively to decide on a destination by voting on the options and choose the most popular destination.',
  },
  {
    id: 'c4c5d797-759c-4566-ad68-4ee74f866681',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Scenario: As a crane operator, you need to communicate effectively with you ground crew to ensure safety on the site. What is the best way to do this?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'd7405544-8970-4fb2-9c24-ea07ae34e688',
        description: '',
        option:
          'Use hand signals and clear verbal instructions to communicate with the ground crew.',
      },
      {
        id: '2b3e221e-2730-4815-bd50-94b404933566',
        description: '',
        option: 'Ignore the ground crew and operate the crane independently.',
      },
      {
        id: 'df64f871-d8cb-4ae9-b43a-185c44dec73b',
        option: 'Only communicate when there’s a problem.',
        description: '',
      },
      {
        id: '76a43dae-feb3-464a-b47b-b96f67739a79',
        option: 'Use a complex system of codes that only you understand',
        description: '',
      },
    ],
    answers: ['d7405544-8970-4fb2-9c24-ea07ae34e688'],
    wrong_answer_description:
      'The best way to do this is to use hand signals and clear verbal instruction to communicate with the ground crew.',
    answer_description:
      'The best way to do this is to use hand signals and clear verbal instruction to communicate with the ground crew.',
  },
  {
    id: '21bb4aa8-a870-4553-a08a-17386b359b12', //pending
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question: 'Scenario: Which of the following jobs requires close collaboration with a team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'e4fe0258-e61b-4f5e-811b-839b8cf2e72f',
        description: '',
        option: 'Accountant working independently on tax returns.',
      },
      {
        id: 'e47a628b-78aa-44ae-beb3-b0c003f8e887',
        description: '',
        option: 'Music producer co-ordinating with artists and sound engineers.',
      },
      {
        id: 'a9b85501-218d-49b1-942a-f4cf4be2abd0',
        option: 'Author writing a book alone.',
        description: '',
      },
      {
        id: '70397711-8869-4557-ac88-aa3385eca52d',
        option: 'Solo painter working on a landscape',
        description: '',
      },
    ],
    answers: ['e47a628b-78aa-44ae-beb3-b0c003f8e887'],
    wrong_answer_description:
      'The job requiring close collaboration with a team include music producer coordinating with artists and sound engineers',
    answer_description:
      'The job requiring close collaboration with a team include music producer coordinating with artists and sound engineers',
  },
  {
    id: 'a44fd9b1-f3f8-4280-b7df-9dd840bbd3d6',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Scenario: You notice that one of your colleagues prefers details plans and strict adherence to schedules. Which engagement style dose this indicate?',
    type: QuestionType.RADIO,
    options: [
      {
        id: 'a6d0de47-6401-4cf9-ad86-85711e0d1cb6',
        description: '',
        option: 'Vision-driven',
      },
      {
        id: '843d5bad-089a-4e44-b759-98eeca0ab6a9',
        description: '',
        option: 'Task-driven',
      },
      {
        id: 'c0ba2da5-adf3-4843-8634-eb34cec56bac',
        option: 'Goal-driven',
        description: '',
      },
      {
        id: '23202153-4d79-4e85-bc82-8e3e69173e73',
        option: 'People-driven',
        description: '',
      },
    ],
    answers: ['c0ba2da5-adf3-4843-8634-eb34cec56bac'],
    wrong_answer_description: 'The engagement style is task driven',
    answer_description: 'The engagement style is task driven',
  },
  {
    id: 'ccc9fb17-fe47-4df7-a277-e2a341f47a14',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Which type of energy does Jamie exhibit, known for their outgoing, creative nature and ability to bring vibrant, positive energy to the team?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '3939aebd-52d9-497f-8b1a-e3e3ad76dd54',
        description: '',
        option: 'Fiery Red Energy',
      },
      {
        id: '26188843-fce0-468d-9eba-065c95a7ac49',
        description: '',
        option: 'Sunshine Yellow Energy',
      },
      {
        id: 'f88c8de1-9a75-4fa9-835e-7699a3fd22c5',
        option: 'Earth Green Energy',
        description: '',
      },
      {
        id: '531a85ec-4355-4af1-9daf-697357905610',
        option: 'Cool Blue Energy',
        description: '',
      },
    ],
    answers: ['26188843-fce0-468d-9eba-065c95a7ac49'],
    wrong_answer_description:
      'Jamie exhibits Sunshine Yellow Energy, characterized by their outgoing and creative nature, and their ability to bring vibrant, positive energy to the team. ',
    answer_description:
      'Jamie exhibits Sunshine Yellow Energy, characterized by their outgoing and creative nature, and their ability to bring vibrant, positive energy to the team. ',
  },
  {
    id: '309c4bfb-1830-4d42-81d5-aa9ed680dcd1',
    chapter_id: '5a9a5e7f-44e8-4d44-a755-0fd31d3ccba',
    course_id: '229be651-ab88-4a7e-bf8b-add2cd29c89c',
    question:
      'Who is most likely to be described as the peacekeeper, focusing on empathy, support, and ensuring feels heard in a team setting?',
    type: QuestionType.RADIO,
    options: [
      {
        id: '1181eb89-12bc-4061-842a-fdb05289d31c',
        description: '',
        option: 'Alex, the captain of the school soccer team',
      },
      {
        id: '3b1b5418-f1bc-4cd9-928b-1ffced5c4594',
        description: '',
        option: 'Jamie, the life of the drama club',
      },
      {
        id: '619287f1-2cb1-47fb-bf0f-9b997805bb09',
        option: 'Sam, the supportive member of the student council',
        description: '',
      },
      {
        id: '0b98a1e2-9e5a-4845-9de9-07c772565015',
        option: 'Taylor, the top student in the math club',
        description: '',
      },
    ],
    answers: ['619287f1-2cb1-47fb-bf0f-9b997805bb09'],
    wrong_answer_description:
      'Sam is described as having Earth Green Energy, focusing on empathy, support, and ensuring everyone feels heard, making them the peacekeeper of the team.',
    answer_description:
      'Sam is described as having Earth Green Energy, focusing on empathy, support, and ensuring everyone feels heard, making them the peacekeeper of the team.',
  },
];
